import React, { useState } from 'react';
//import GroupSign from '../group_signs/Group_signs';
import './Show_groups_signs.css';
import { useNavigate } from "react-router-dom"; 
import ZodiacWheel from '../rueda/ZodiacWheel';

const ShowGroupsSigns = ({ label }) => {
    const [selectSings, setSelectSings] = useState([]);
    const navigate = useNavigate();

    const addSign = (nuevoString) => {
        // Permitir agregar el mismo string varias veces
        const updatedSings = [...selectSings, nuevoString];
        setSelectSings(updatedSings);
        console.log("Nuevo string agregado:", nuevoString);

        // Redirigir si estamos en compatibilidad y si hay exactamente 2 signos seleccionados
        if (label === "compatibilidad" && updatedSings.length === 2) {
            navigate(`/compatibilidad/${updatedSings[0].toLowerCase()}/${updatedSings[1].toLowerCase()}`);
        }
    };
    // Redirigir solo cuando ambos signos están seleccionados y label es compatibilidad
    const messages = {
        "horoscopo": {
            title: "Horóscopo Diario",
            description: "Selecciona tu signo",
            subDescription: "y consulta tu Horóscopo diario"
        },
        "frase": {
            title: "Frase del día ",
            description: "fecha",
            subDescription: "Una frase poderosa para iluminar tu camino."
        },
        "compatibilidad": {
            title: "Compatibilidad de signos",
            description: "Selecciona dos signos",
            subDescription: "y consulta tu compatibilidad"
        },
        "tirada": {
            title: "Tirada Tarot",
            description: "Da clic a la carta",
            subDescription: "Y consulta tu tirada"
        },
        // Valores por defecto
        default: {
            title: "default",
            description: "default",
            subDescription: "default"
        }
    };

    // Obtener el mensaje correspondiente o el por defecto
    const { title, description, subDescription } = messages[label] || messages["horoscopo"];

    return (
        <div className="container_group">
            <div className='title-action'>
                {title}
            </div>
            <div className='title-description'>
                {description}
            </div>
            <div className='title-description-2'>
                {subDescription}
            </div>

             {/* Rueda Zodiacal */}
             <div className='rueda'>
                <ZodiacWheel />
             </div>
             
              
            {/* <div className="row">
                <div className="col s12 m6 l3"><GroupSign group="fire" label={label} addSign={addSign}/></div>
                <div className="col s12 m6 l3"><GroupSign group="earth" label={label} addSign={addSign}/></div>
                <div className="col s12 m6 l3"><GroupSign group="air" label={label} addSign={addSign}/></div>
                <div className="col s12 m6 l3"><GroupSign group="water" label={label} addSign={addSign}/></div>
            </div> */}
        </div>
    );
};

export default ShowGroupsSigns;
